import React from 'react';
import neonPc from '../../../assets/services-pages/pc.jpg';
import { Helmet } from 'react-helmet';
import './app-dev.css';

export default function AppDevelopment() {
    return (
        <>
            <Helmet>
                <title>Application Development | ERA Automation & Software | ERA Software | App Development Services</title>
                <meta
                    name="description"
                    content="Our expert app development team builds custom mobile applications that enhance user experience and drive business growth. Let us bring your app ideas to life."
                />
                <meta
                    name="keywords"
                    content="Mobile App Development, Desktop App Development, Application Development, ERA Software, ERA Automation and Software, Mobile Applications, cross-platform app development, app development company, Desktop Applications, Custom App Development, iOS app development, Android app development, app development for businesses"
                />
            </Helmet>

            <div className=" bg-black text-white">
                {/* Hero Section */}
                <div className="h-screen  flex flex-col items-center justify-center text-center px-4 sm:px-16 ">
                    <h1 className="uppercase text-4xl sm:text-5xl md:text-6xl leading-loose">
                        We are creating your <br />
                        <span className="font-italiana text-6xl sm:text-7xl md:text-8xl">dream</span>
                    </h1>
                    <p className="text-lg sm:text-xl md:text-2xl mt-8">
                        By building exceptional mobile and web applications that are not only functional but also visually stunning, ensuring your brand resonates with users.
                    </p>
                </div>

                {/* Mobile App Section */}
                <div className="bg-black text-white grid grid-cols-1 md:grid-cols-2 gap-8 py-16 px-4 sm:px-16 lg:h-screen  md:h-1/2 sm:h-full ">
                    <div className="flex justify-center items-center text-center md:text-left">
                        <h1 className="uppercase text-3xl sm:text-4xl md:text-5xl">
                            Mobile Application Development
                        </h1>
                    </div>
                    <div className="flex justify-center items-center">
                        <p className="text-base sm:text-lg md:text-xl max-w-screen-md ">
                            We specialize in crafting mobile applications that deliver exceptional user experiences across both iOS and Android platforms. Whether it's creating intuitive interfaces or integrating powerful features, we ensure your app meets the needs of modern users. Our mobile apps are built to be user-friendly, high-performing, and seamlessly integrated with your business objectives.
                            <br />
                            <span className="italic text-sm sm:text-lg">Funny One-Liner: "We build mobile apps so engaging, your phone might just ask for a break!"</span>
                        </p>
                    </div>
                </div>

                {/* Image Section */}
                <div
                    className="relative w-full h-80 sm:h-[50vh] md:h-screen bg-cover bg-center"
                    style={{ backgroundImage: `url(${neonPc})` }}
                ></div>

                {/* Desktop App Section */}
                <div className="w-screen lg:h-screen md:h-1/2 sm:h-full bg-black text-white grid grid-cols-1 md:grid-cols-2 gap-8 py-16 px-4 sm:px-16 desktop ">
                    
                    <div className="flex justify-center items-center order-2 md:order-1 desktop-inf">
                        <p className="text-base sm:text-lg md:text-xl max-w-screen-md  md:text-left">
                            Our desktop applications are designed to enhance productivity, efficiency, and performance, tailored to meet your business’s specific requirements. From custom solutions to enterprise-grade software, we create powerful desktop apps that streamline workflows and drive success.
                            <br />
                            <span className="italic text-sm sm:text-lg">Funny One-Liner: "Creating desktop apps that make your computer feel like it just got promoted to CEO!"</span>
                        </p>
                    </div>

                    <div className="flex justify-center items-center order-1 md:order-2 text-center desktop-title">
                        <h1 className="uppercase text-3xl sm:text-4xl md:text-5xl">
                            Desktop Application
                        </h1>
                    </div>
                </div>

            </div>
        </>
    );
}
